import React, { useState } from "react";
import toast from "react-hot-toast";
import {
  ApiCrearComidaPeriodo,
  ApiEditarComidaPeriodo,
} from "../../../api/comidasPeriodo";

const CrearComidaPeriodo = ({
  updateListFn,
  state,
  setState,
  type,
  setType,
  resetState,
  listadoPeriodos,
  listadoComidas,
}) => {
  const [loading, setlLoading] = useState(false);
  const fields = [
    { name: "pre_periodo_id", label: "Periodo" },
    { name: "pre_comida_id", label: "Comida" },
    { name: "horas_antes", label: "Horas de anticipacion" },
    { name: "maximo_persona", label: "Maximo de solicitudes por persona" },
  ];

  const onchange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const emptyFields = fields.filter((campo) => !state[campo.name]);

  const CrearFn = async () => {
    setlLoading(true);
    if (emptyFields.length > 0) {
      const mensajes = emptyFields.map(
        (campo) => `El campo "${campo.label}" no puede estar vacío.`
      );
      const mensajeError = mensajes.join("\n");
      toast.error(mensajeError, {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setlLoading(false);
      return;
    }

    const res =
      type === "save"
        ? await ApiCrearComidaPeriodo(state)
        : await ApiEditarComidaPeriodo(state);

    const datares = res;
    if (datares.sms === "ok") {
      toast.success(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setType("save");
      resetState();
      updateListFn();
    } else {
      toast.error(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    setlLoading(false);
  };

  return (
    <div>
      <div className="row mt-3 mb-4">
        <div className="col-md-6 col-lg-4  w-100">
          <div
            className=" bg-white  border-0 borde-tarjeta"
            style={{ height: "auto" }}
          >
            <div className="card-body m-0 p-0">
              <div className="w-100 bgfondo2 bordeabajo bordesombreado d-flex flex-column align-items-center d-flex justify-content-center py-3 px-3">
                <div className="w-100  d-flex justify-content-between align-items-center px-3">
                  <h5 className=" negrita card-title">
                    {type === "save" ? "Crear" : "Editar"} Comida por Periodo
                  </h5>
                  <div className="d-flex justify-content-between flex-row align-self-start">
                    <div className="d-flex justify-content-end ">
                      {loading ? (
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <button
                          type=""
                          className="bg-btn-vet bordesombreado"
                          onClick={() => CrearFn()}
                        >
                          <i className="fas fa-save mx-2"></i>
                          {type === "save" ? "Guardar" : "Editar"} Comida por
                          Periodo
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row py-4 ">
                <div className="col-md-6">
                  <label className="py-2 negrita">Periodo</label>
                  <select
                    id="pre_periodo_id"
                    name="pre_periodo_id"
                    value={state.pre_periodo_id}
                    className="inputtext2 bordecompleto"
                    onChange={onchange}
                  >
                    <option value="">Seleccione un periodo</option>
                    {listadoPeriodos.map((periodo) => (
                      <option
                        key={periodo.pre_periodo_id}
                        value={periodo.pre_periodo_id}
                      >
                        {periodo.nombre}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Comida</label>
                  <select
                    id="pre_comida_id"
                    name="pre_comida_id"
                    value={state.pre_comida_id}
                    className="inputtext2 bordecompleto"
                    onChange={onchange}
                  >
                    <option value="">Seleccione una comida</option>
                    {listadoComidas.map((comida) => (
                      <option
                        key={comida.pre_comida_id}
                        value={comida.pre_comida_id}
                      >
                        {comida.nombre}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="py-2 negrita">Horas de anticipación</label>
                  <input
                    type="number"
                    id="horas_antes"
                    name="horas_antes"
                    value={state.horas_antes}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite las horas de anticipacion"
                    onChange={onchange}
                    min="0"
                  />
                </div>
                <div className="col-md-4">
                  <label className="py-2 negrita">
                    Máximo de solicitudes por persona
                  </label>
                  <input
                    type="number"
                    id="maximo_persona"
                    name="maximo_persona"
                    value={state.maximo_persona}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite el maximo de solicitudes por persona"
                    onChange={onchange}
                    min="0"
                  />
                </div>
                <div className="col-md-4">
                  <label className="py-2 negrita">Subsidio</label>
                  <input
                    type="number"
                    id="subsidio"
                    name="subsidio"
                    value={state.subsidio}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite el maximo de solicitudes por persona"
                    onChange={onchange}
                    min="0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrearComidaPeriodo;
